import {requestWithToken, simpleRequest} from "../apiConfigs/request";

export const loginCandidate = (userCred) => {
    return simpleRequest({
        url: '/auth/candidate/login',
        method: 'POST',
        data: userCred
    });
}

export const fetchUserInfo = () => {
    return requestWithToken({
        url: '/auth/candidate/me',
        method: "GET"
    })
}

export const logOutUserService = ()=> {
    return requestWithToken({
        url: '/auth/candidate/logout',
        method: "POST",
        data: {
            refreshToken: localStorage.getItem("candidateRefreshToken") || ""
        }
    })
}

export const callRefresh = () => {
    return simpleRequest({
        url: '/auth/candidate/refresh-tokens',
        method: "POST",
        data: {
            refreshToken: localStorage.getItem("candidateRefreshToken") || ""
        }
    })
}

export const forgotPassword = (data) => {
    return simpleRequest({
        url: '/auth/candidate/forgot-password',
        method: "POST",
        data,
    })
}

export const resetPassword = (query="", data) => {
    return simpleRequest({
        url: `/auth/candidate/reset-password${query}`,
        method: "POST",
        data,
    })
}

const AuthService = {
    callRefresh,
}
export default AuthService;
